import React from 'react';
import { IconProps } from './createIcon';
import {
  AlignLeftIcon,
  CheckboxIcon,
  DateIcon,
  DateTimeIcon,
  EmailIcon,
  LinkIcon,
  MultipleChoiceIcon,
  NumericIcon,
  PhoneIcon,
  QuestionMarkIcon,
  TimeIcon,
} from './default';

export enum FormQuestionType {
  TEXT = 'CustomField__String',
  NUMERIC = 'CustomField__Numeric',
  CHECKBOXES = 'CustomField__Checkboxes',
  MULTIPLECHOICE = 'CustomField__MultipleChoice',
  DATE = 'CustomField__Date',
  TIME = 'CustomField__Time',
  DATETIME = 'CustomField__DateTime',
  PHONE = 'CustomField__PhoneNumber',
  EMAIL = 'CustomField__Email',
  LINK = 'CustomField__Link',
}

interface FileIconProps extends IconProps {
  questionType?: FormQuestionType;
}

export const QuestionIcon = ({ questionType, ...props }: FileIconProps) => {
  switch (questionType) {
    case FormQuestionType.TEXT:
      return <AlignLeftIcon {...props} />;
    case FormQuestionType.CHECKBOXES:
      return <CheckboxIcon {...props} />;
    case FormQuestionType.NUMERIC:
      return <NumericIcon {...props} />;
    case FormQuestionType.MULTIPLECHOICE:
      return <MultipleChoiceIcon {...props} />;
    case FormQuestionType.DATE:
      return <DateIcon {...props} />;
    case FormQuestionType.TIME:
      return <TimeIcon {...props} />;
    case FormQuestionType.DATETIME:
      return <DateTimeIcon {...props} />;
    case FormQuestionType.PHONE:
      return <PhoneIcon {...props} />;
    case FormQuestionType.EMAIL:
      return <EmailIcon {...props} />;
    case FormQuestionType.LINK:
      return <LinkIcon {...props} />;
    default:
      return <QuestionMarkIcon {...props} />;
  }
};
